import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getSupplierCardLogosSaga } from '../../Hooks/actionCreators';

/**
 * Triggers the action to get the brand logo urls for all SupplierCard components in the form.
 */
const SupplierCardBrandManager = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSupplierCardLogosSaga());
  }, []);

  return null;
};

export default SupplierCardBrandManager;
